import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Config } from '../../common/config';
import { fetchCodeDetailList } from '../../common/fetchCodeDetailList';
import axios from 'axios';
import AlertModal from '../../components/alertModal';

import { getPostcode } from '../../components/zip';
import { useSelector } from 'react-redux';
import { translations } from '../../data/translation';
import { messages } from '../../data/messages';

export const AgeRestriction = {
  GENERAL: '전체 이용가',
  ADULT: '성인 이용가',
};

export default function StoreContent(props) {
  const language = useSelector(state => state.language.language);
  const t = translations[language];
  const msg = messages[language];
  var script = document.createElement('script');
  script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
  // script.src = Config.ADDRESS_SRC;
  document.head.appendChild(script);

  const navigate = useNavigate();
  const [imageFileName, setImageFileName] = useState(null);
  const [modalOpen, setModalOpen] = useState(false); //모달 상태 관리 : 기본값 - 닫힘
  const [modalInfo, setModalInfo] = useState({
    isCancel: false,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '',
    action: '',
    isPercent: false,
  });
  const [storeName, setStoreName] = useState('');
  const [representativeName, setRepresentativeName] = useState('');
  const [bizCertFile, setBizCertFile] = useState(null);
  const [sms1, setSms1] = useState('');
  const [sms2, setSms2] = useState('');
  const [sms3, setSms3] = useState('');
  const [zipCode, setzipCode] = useState('');
  const [addr, setAddr] = useState('');
  const [detailAddr, setDetailAddr] = useState('');
  const [jibun, setJibun] = useState('');
  let phone = '';
  const [accountNo, setAccountNo] = useState('');
  const [accountHolder, setAccountHolder] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [bankCode, setBankCode] = useState('');
  const [bankData, setBankData] = useState([]);
  const [phoneHint, setPhoneHint] = useState('');
  const [validationBankCode, setValidationBankCode] = useState('');
  const [, setValidationAccountNo] = useState('');
  const [, setValidationName] = useState('');
  const [validationBirthYear, setValidationBirthYear] = useState('');
  const [validationBirthMonth, setValidationBirthMonth] = useState('');
  const [validationBirthDay, setValidationBirthDay] = useState('');
  // account validation UI states (kept minimal, message hidden)
  const [, setAccountValidationMsg] = useState('');
  const [, setAccountValidationStatus] = useState('idle');
  const [, setValidatedAccountInfo] = useState(null);
  // 계좌 인증을 어떤 유형으로 통과했는지 (BT003: 법인 계좌 인증 / BT002: 개인 계좌 인증)
  const [validatedAccountBizType, setValidatedAccountBizType] = useState('');
  // 법인 계좌 인증에 사용한 사업자번호 (이후 사업자번호가 바뀌면 재인증)
  const [validatedAccountBizNo, setValidatedAccountBizNo] = useState('');
  const [bizNum, setBizNum] = useState('');
  const [repStoreYn] = useState('N');
  const [bizNumHint, setBizNumHint] = useState('');
  const [bizNum1, setBizNum1] = useState('');
  const [bizNum2, setBizNum2] = useState('');
  const [bizNum3, setBizNum3] = useState('');
  const [isBizVerified, setIsBizVerified] = useState(false);
  const [bizVerifyMsg, setBizVerifyMsg] = useState('');
  const [bizType, setBizType] = useState('BT002'); // BT002 개인사업자 / BT003 법인사업자 (BT001은 서버 제공 시에만 노출)
  const [bizTypeOptions, setBizTypeOptions] = useState([]);
  const [naverUrl, setNaverUrl] = useState('');
  const [kakaoUrl, setKakaoUrl] = useState('');
  const [instagramUrl, setInstagramUrl] = useState('');
  const [ageRestriction, setAgeRestriction] = useState(AgeRestriction.GENERAL);
  const [selectedStoreNo, setSelectedStoreNo] = useState(null);
  const [storeSearchModalOpen, setStoreSearchModalOpen] = useState(false);
  const [storeSearchQuery, setStoreSearchQuery] = useState('');
  const [storeSearchResults, setStoreSearchResults] = useState([]);
  const [storeSearchLoading, setStoreSearchLoading] = useState(false);

  const openStoreSearchModal = () => setStoreSearchModalOpen(true);
  const closeStoreSearchModal = () => {
    setStoreSearchModalOpen(false);
    setStoreSearchQuery('');
    setStoreSearchResults([]);
  };

  const searchStores = async () => {
    const q = (storeSearchQuery || '').trim();
    if (!q) return;
    setStoreSearchLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_SERVER_ADMIN}store/temp-search?storeName=${encodeURIComponent(q)}`
      );
      const list = res?.data?.data?.data ?? res?.data?.data ?? [];
      setStoreSearchResults(Array.isArray(list) ? list : []);
    } catch (err) {
      setStoreSearchResults([]);
    } finally {
      setStoreSearchLoading(false);
    }
  };

  const selectStoreFromSearch = item => {
    setStoreName(item.storeName || '');
    setAgeRestriction(item.ageRestriction || AgeRestriction.GENERAL);
    setzipCode(item.zipCode || '');
    setAddr(item.addr || '');
    setJibun(item.addrJibun || item.addr || '');
    setDetailAddr(item.detAddr || '');
    const ph = (item.phone || '').replace(/\D/g, '');
    if (ph.length >= 10) {
      setSms1(ph.slice(0, 3));
      setSms2(ph.slice(3, ph.length - 4));
      setSms3(ph.slice(-4));
    }
    setSelectedStoreNo(item.storeNo);
    closeStoreSearchModal();
  };

  const openModal = e => {
    if (modalInfo.actionFlag === 'accountNo') {
      setModalInfo({
        ...modalInfo,
        mainMsg: msg.accountNoFormat,
      });
    } else if (modalInfo.actionFlag === 'api') {
      setModalInfo({
        ...modalInfo,
        mainMsg: msg.apiError,
      });
    } else if (modalInfo.actionFlag === 'mail') {
      setModalInfo({
        ...modalInfo,
        mainMsg: msg.sendingMailSms,
      });
    } else if (modalInfo.actionFlag === 'register') {
      setModalInfo({
        ...modalInfo,
        mainMsg: msg.storeRegistering,
      });
    }

    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const doModal = () => {
    setModalOpen(false);
  };

  const validatePhone = () => {
    const hasNumber1 = !isNaN(sms1) && sms1.length > 0;
    const hasNumber2 = !isNaN(sms2) && sms2.length > 0;
    const hasNumber3 = !isNaN(sms3) && sms3.length > 0;
    if (!hasNumber1 || !hasNumber2 || !hasNumber3) {
      modalInfo.mainMsg = msg.phoneFormatStore;
      return false;
    }
    // 휴대폰 010-XXXX-XXXX (3-4-4)
    const isMobile = sms1 === '010' && sms2.length === 4 && sms3.length === 4;
    // 서울 02-XXX-XXXX 또는 02-XXXX-XXXX (2-3-4 또는 2-4-4)
    const isSeoul =
      sms1 === '02' &&
      (sms2.length === 3 || sms2.length === 4) &&
      sms3.length === 4;
    // 지역번호 031-XXX-XXXX, 032-XXX-XXXX 등 (3-3-4)
    const isLocal =
      sms1.length === 3 &&
      sms1 !== '010' &&
      sms2.length === 3 &&
      sms3.length === 4;

    if (isMobile || isSeoul || isLocal) {
      phone = sms1 + '-' + sms2 + '-' + sms3;
      return true;
    }
    modalInfo.mainMsg = msg.phoneFormatStore;
    return false;
  };

  const setAddress = e => {
    const postEl = document.getElementById('postcode');
    const roadEl = document.getElementById('roadAddress');
    const jibunEl = document.getElementById('jibunAddress');
    if (postEl?.value) setzipCode(postEl.value);
    if (roadEl?.value) setAddr(roadEl.value);
    if (jibunEl?.value) setJibun(jibunEl.value);
    setDetailAddr(e.target.value);
  };

  const openAddressSearch = () => {
    getPostcode({
      setZipCode: setzipCode,
      setAddr: setAddr,
      setJibun: setJibun,
    });
  };

  // 초기 로딩 데이터(은행/사업자유형)는 마운트 시 1회 조회

  const getBankNameByCode = code => {
    if (!code) return '';
    const bank = bankData.find(item => item.detailCode === code);
    return bank ? bank.detailCodeName : '';
  };

  /**
   * 사업자번호 가운데 2자리(4~5번째)로 개인/법인 구분
   * 법인: 81, 82, 83, 84, 85, 86, 87, 88
   * 개인: 01~80, 89, 90~99
   */
  const getBizTypeFromMiddleDigits = middle2 => {
    const n = parseInt(middle2, 10);
    if (isNaN(n) || n < 0 || n > 99) return 'BT002'; // 기본 개인
    if (n >= 81 && n <= 88) return 'BT003'; // 법인
    return 'BT002'; // 개인
  };

  const handleResetValidationState = () => {
    setAccountValidationStatus('idle');
    setAccountValidationMsg('');
    setValidatedAccountInfo(null);
  };

  // popup 방식으로 변경됨: 직접 검증 호출 함수는 제거

  // applyValidatedAccount: no longer used (auto-apply via popup message)

  const handleOpenValidationModal = () => {
    // 계좌 실명조회는 사업자번호 조회(개인/법인 판별)가 끝난 뒤에만 가능
    if (bizType !== 'BT001' && !isBizVerified) {
      setModalInfo({ ...modalInfo, mainMsg: msg.bizNumVerifyBeforeAccount });
      setModalOpen(true);
      return;
    }
    try {
      // expose bank list to popup
      window.__NAEGIFT_BANK_OPTIONS__ = bankData || [];
    } catch (e) {}
    if (!validationBankCode && bankData.length > 0) {
      setValidationBankCode(bankData[0].detailCode);
    }
    if (!validationBirthYear) {
      setValidationBirthYear('');
      setValidationBirthMonth('');
      setValidationBirthDay('');
    }
    const saved = JSON.parse(localStorage.getItem('totalUserData') || '{}');
    const nameForValidation =
      accountHolder || saved.adminName || saved.name || '';
    setValidationName(nameForValidation);
    setValidationAccountNo(accountNo || '');
    // 사업자번호 조회로 법인이 확인된 경우 법인 계좌 인증(사업자번호) 팝업으로 연다
    const isCorporate = isBizVerified && bizType === 'BT003';
    const params = new URLSearchParams({
      ...(isCorporate && { bizType: 'BT003', bizNo: bizNum }),
      name: isCorporate ? '' : nameForValidation,
      year: validationBirthYear || '',
      month: validationBirthMonth || '',
      day: validationBirthDay || '',
      // 현재 폼 값 기준으로 채운다 (재조회로 계좌를 비운 뒤 이전 계좌번호가 팝업에 남지 않도록)
      bankCode: bankCode || validationBankCode || '',
      accountNo: accountNo || '',
      lang: language || 'ko',
    });
    const url = `${
      window.location.origin
    }/popup/account-validation?${params.toString()}`;
    window.open(
      url,
      'accountValidation',
      'width=420,height=660,menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes'
    );
  };

  // Receive result from popup
  useEffect(() => {
    const handler = event => {
      const data = event?.data;
      if (!data || data.type !== 'ACCOUNT_VALIDATION_RESULT') return;
      if (data.success && data.data) {
        // Auto-apply values to store fields
        setBankCode(data.data.bankCode || '');
        setAccountNo(data.data.accountNo || '');
        // 법인 계좌 인증은 예금주를 받지 않음 — 인증 후 예금주 칸에 법인명을 직접 입력한다
        setAccountHolder(
          data.data.bizType === 'BT003' ? '' : data.data.accountHolder || ''
        );
        setValidatedAccountBizType(
          data.data.bizType === 'BT003' ? 'BT003' : 'BT002'
        );
        setValidatedAccountBizNo(data.data.bizNo || '');
        setAccountValidationStatus('success');
        setAccountValidationMsg('');
        setValidatedAccountInfo(null);
      } else {
        setAccountValidationStatus('error');
        setAccountValidationMsg('');
        setValidatedAccountInfo(null);
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  const checkStoreData = () => {
    if (!storeName) {
      modalInfo.mainMsg = msg.storeNameRequired;
      return false;
    }
    if (!representativeName || representativeName.trim().length === 0) {
      modalInfo.mainMsg = msg.representativeNameRequired;
      return false;
    }
    if (!bizCertFile) {
      modalInfo.mainMsg = msg.bizCertFileRequired;
      return false;
    }
    if (bizType !== 'BT001') {
      if (
        !(bizNum1.length === 3 && bizNum2.length === 2 && bizNum3.length === 5)
      ) {
        modalInfo.mainMsg = msg.bizNumFormat;
        return false;
      }
      if (!isBizVerified) {
        modalInfo.mainMsg = msg.bizNumVerifyRequired;
        return false;
      }
    }
    const validPhone = validatePhone();
    if (!validPhone) return false;
    if (!phone) {
      modalInfo.mainMsg = msg.phoneRequired;
      return false;
    }
    if (!zipCode) {
      modalInfo.mainMsg = msg.postalCodeRequiredStore;
      return false;
    }
    if (!addr) {
      modalInfo.mainMsg = msg.roadAddressRequiredStore;
      return false;
    }
    if (!jibun) {
      modalInfo.mainMsg = msg.jibunAddressRequiredStore;
      return false;
    }
    if (!detailAddr || detailAddr.trim().length === 0) {
      modalInfo.mainMsg = msg.detailAddrRequired;
      return false;
    }
    if (!bankCode) {
      modalInfo.mainMsg = msg.bankRequired;
      return false;
    }
    if (!accountNo) {
      modalInfo.mainMsg = msg.accountNoRequired;
      return false;
    }
    if (!accountHolder) {
      modalInfo.mainMsg = msg.accountHolderRequired;
      return false;
    }
    // 계좌 인증 후 사업자 유형이 바뀐 경우(개인으로 인증 → 법인 확인 등) 재인증 필요
    const expectedAccountBizType = bizType === 'BT003' ? 'BT003' : 'BT002';
    if (
      validatedAccountBizType !== expectedAccountBizType ||
      (expectedAccountBizType === 'BT003' && validatedAccountBizNo !== bizNum)
    ) {
      modalInfo.mainMsg =
        expectedAccountBizType === 'BT003'
          ? msg.accountRevalidateCorporate
          : msg.accountRevalidatePersonal;
      return false;
    }

    return true;
  };

  const goNextToUser = () => {
    if (checkStoreData() !== true) {
      setModalInfo({ ...modalInfo });
      setModalOpen(true);
      return;
    }
    const phoneVal = sms1 + '-' + sms2 + '-' + sms3;
    const totalStoreData = {
      storeName,
      representativeName,
      phone: phoneVal,
      zipCode,
      addr,
      detailAddr,
      jibun,
      bankCode,
      accountNo,
      accountHolder,
      bizNum: bizType === 'BT001' ? '1' : bizNum,
      bizType,
      repStoreYn,
      naverUrl,
      kakaoUrl,
      instagramUrl,
      ageRestriction,
      sms1,
      sms2,
      sms3,
      ...(selectedStoreNo != null && { storeNo: selectedStoreNo }),
    };
    localStorage.setItem('totalStoreData', JSON.stringify(totalStoreData));
    navigate('/user-content', {
      state: { imageFile: imageFileName, bizCertFile },
    });
  };

  const changeFile = e => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 3 * 1024 * 1024) {
        e.target.value = null;
        modalInfo.mainMsg = msg.imageSizeLimit;
        setModalOpen(true);
      } else {
        setImageFile(URL.createObjectURL(file)); // 선택된 파일을 URL.createObjectURL을 사용하여 미리보기로 보여줌
        setImageFileName(file);
      }
    } else {
      setImageFile(null);
    }
  };

  const changeBizCertFile = e => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        e.target.value = null;
        modalInfo.mainMsg = msg.bizCertFileSizeLimit;
        setModalOpen(true);
      } else {
        setBizCertFile(file);
      }
    } else {
      setBizCertFile(null);
    }
  };

  const cancelUser = async () => {
    try {
      const saved = JSON.parse(localStorage.getItem('totalUserData') || '{}');
      if (saved.id && saved.id.length > 0) {
        const cancelData = { userId: saved.id };
        await axios.put(`${Config.API_SERVER}user/pro`, cancelData);
      }

      navigate('/');
    } catch (error) {
      if (error.response) {
        modalInfo.actionFlag = 'api';
        openModal();
      } else if (error.request) {
        modalInfo.actionFlag = 'api';
        openModal();
      } else {
        modalInfo.actionFlag = 'api';
        openModal();
      }
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    const fetchInitData = async () => {
      try {
        const list = await fetchCodeDetailList(
          Config.API_CODE_DETAIL,
          'NG11',
          url => axios.get(url, { withCredentials: true }),
        );
        setBankData(list);
      } catch (error) {
        console.error('Error getData:', error);
      }

      try {
        const ret = await axios.get(
          `${Config.API_CODE_DETAIL}?pageSize=40&sortOrd=asc&groupCode=NG14`,
          { withCredentials: true }
        );

        const list = ret?.data?.data?.list || [];
        const filtered = list.filter(
          item => item?.useYn === 'Y' && item?.delYn === 'N'
        );

        // 서버 제공 코드 기준으로만 렌더링 (BT001 보강/추가 없음)
        // BT001 -> BT002 -> BT003 순서 우선 (서버가 BT001을 내려주는 경우만)
        const order = { BT001: 1, BT002: 2, BT003: 3 };
        filtered.sort((a, b) => {
          const ao = order[a.detailCode] ?? 999;
          const bo = order[b.detailCode] ?? 999;
          if (ao !== bo) return ao - bo;
          return (a.codeDetailNo ?? 0) - (b.codeDetailNo ?? 0);
        });

        setBizTypeOptions(filtered);
      } catch (error) {
        console.error('Error getBizTypeData:', error);
        setBizTypeOptions([]);
      }
    };

    fetchInitData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 사업자 유형 목록이 로드되면 현재 선택값 보정
  useEffect(() => {
    if (!bizTypeOptions || bizTypeOptions.length === 0) return;
    if (!bizTypeOptions.some(it => it.detailCode === bizType)) {
      setBizType(bizTypeOptions[0].detailCode);
    }
  }, [bizTypeOptions, bizType]);

  // 은행 데이터가 로드되면 첫 번째 은행을 기본값으로 설정
  useEffect(() => {
    if (bankData && bankData.length > 0) {
      if (!validationBankCode) {
        setValidationBankCode(bankData[0].detailCode);
      }
    }
  }, [bankData, bankCode, validationBankCode]);

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        action={doModal}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
      >
        {modalInfo.mainMsg}
      </AlertModal>

      {storeSearchModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={closeStoreSearchModal}
        >
          <div
            style={{
              background: '#fff',
              padding: 24,
              borderRadius: 8,
              minWidth: 480,
              maxWidth: 90,
              maxHeight: '80vh',
              overflow: 'auto',
            }}
            onClick={e => e.stopPropagation()}
          >
            <h3 style={{ margin: '0 0 16px 0' }}>{t.storeSearch}</h3>
            <p className="font_gray" style={{ marginBottom: 12, fontSize: 13 }}>
              {t.storeSearchHint}
            </p>
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              <input
                className="input_01"
                type="text"
                placeholder={t.storeSearchPlaceholder}
                value={storeSearchQuery}
                onChange={e => setStoreSearchQuery(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && searchStores()}
                style={{ flex: 1 }}
              />
              <button
                type="button"
                className="button_05 button_blue"
                onClick={searchStores}
                disabled={storeSearchLoading}
              >
                {storeSearchLoading ? t.searching : t.search}
              </button>
              <button
                type="button"
                className="button_05 button_gray"
                onClick={closeStoreSearchModal}
              >
                {t.close}
              </button>
            </div>
            <div
              style={{
                border: '1px solid #ddd',
                borderRadius: 4,
                maxHeight: 320,
                overflow: 'auto',
              }}
            >
              {storeSearchResults.length === 0 && !storeSearchLoading && (
                <div
                  style={{
                    padding: 24,
                    textAlign: 'center',
                    color: '#888',
                  }}
                >
                  {storeSearchQuery.trim()
                    ? t.noSearchResult
                    : t.storeSearchEmptyHint}
                </div>
              )}
              {storeSearchResults.map(item => (
                <div
                  key={item.storeNo}
                  onClick={() => selectStoreFromSearch(item)}
                  style={{
                    padding: '12px 16px',
                    borderBottom: '1px solid #eee',
                    cursor: 'pointer',
                  }}
                >
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>
                    {item.storeName}
                  </div>
                  <div className="font_gray" style={{ fontSize: 12 }}>
                    {[item.category, item.ageRestriction]
                      .filter(Boolean)
                      .join(' · ')}
                    {item.phone && ` · ${item.phone}`}
                    {item.addr && ` · ${item.addr}`}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <section className="location_box">
        <ul className="location_001">
          <li>{t.home}</li>
          <li>{t.signup}</li>
          <li>{t.storeInfo}</li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_02">
          <h2 className="tit_01">{t.signup}</h2>

          <article className="signup_03">
            <h3 className="tit_02">{t.storeInfo}</h3>
            <p>
              {t.storeInfoDescription1}
              <br />
              {t.storeInfoDescription2}
            </p>
          </article>

          <article className="contants_box_03">
            <table className="member_box">
              <tbody>
                <tr>
                  <th>{t.bizNum}</th>
                  <td>
                    <form>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                        }}
                      >
                        <input
                          className="input_02"
                          type="text"
                          name=""
                          maxLength={3}
                          value={bizNum1}
                          onChange={e => {
                            const raw = e.target.value || '';
                            const digits = raw.replace(/\D/g, '').slice(0, 3);
                            setBizNumHint(raw !== digits ? msg.digitsOnly : '');
                            setBizNum1(digits);
                            setBizNum(digits + bizNum2 + bizNum3);
                            setIsBizVerified(false);
                            setBizVerifyMsg('');
                          }}
                        />
                        -
                        <input
                          className="input_02"
                          type="text"
                          name=""
                          maxLength={2}
                          value={bizNum2}
                          onChange={e => {
                            const raw = e.target.value || '';
                            const digits = raw.replace(/\D/g, '').slice(0, 2);
                            setBizNumHint(raw !== digits ? msg.digitsOnly : '');
                            setBizNum2(digits);
                            setBizNum(bizNum1 + digits + bizNum3);
                            setIsBizVerified(false);
                            setBizVerifyMsg('');
                          }}
                        />
                        -
                        <input
                          className="input_02"
                          type="text"
                          name=""
                          maxLength={5}
                          value={bizNum3}
                          onChange={e => {
                            const raw = e.target.value || '';
                            const digits = raw.replace(/\D/g, '').slice(0, 5);
                            setBizNumHint(raw !== digits ? msg.digitsOnly : '');
                            setBizNum3(digits);
                            setBizNum(bizNum1 + bizNum2 + digits);
                            setIsBizVerified(false);
                            setBizVerifyMsg('');
                          }}
                        />
                        <button
                          type="button"
                          className="button_05 button_gray"
                          onClick={async () => {
                            // 사업자번호를 다시 조회하면 개인/법인이 달라질 수 있으므로 기존 계좌 인증 결과는 비운다
                            if (validatedAccountBizType) {
                              setBankCode('');
                              setAccountNo('');
                              setAccountHolder('');
                              setValidatedAccountBizType('');
                              setValidatedAccountBizNo('');
                            }
                            try {
                              const onlyDigits = (bizNum || '').replace(
                                /\D/g,
                                ''
                              );
                              if (onlyDigits.length !== 10) {
                                setBizVerifyMsg(msg.bizNumVerifyAll);
                                setIsBizVerified(false);
                                return;
                              }
                              const payload = { bNo: onlyDigits };
                              const resp = await axios.post(
                                Config.API_BIZ_VALIDATION_STATUS,
                                payload,
                                {
                                  headers: {
                                    'Content-Type': 'application/json',
                                    Accept: 'application/json',
                                  },
                                }
                              );
                              const body =
                                resp && resp.data ? resp.data.data : null;
                              if (
                                !body ||
                                body.status_code !== 'OK' ||
                                !Array.isArray(body.data)
                              ) {
                                setBizVerifyMsg(msg.bizNumNtsError);
                                setIsBizVerified(false);
                                return;
                              }
                              const item = body.data[0] || {};
                              if (
                                !item ||
                                item.tax_type ===
                                  '국세청에 등록되지 않은 사업자등록번호입니다.' ||
                                !item.b_stt_cd
                              ) {
                                setBizVerifyMsg(msg.bizNumNotRegistered);
                                setIsBizVerified(false);
                                return;
                              }
                              // 폐업 사업자 차단: b_stt_cd '03' = 폐업, b_stt에 '폐업' 포함 시 차단
                              const isClosed =
                                item.b_stt_cd === '03' ||
                                (item.b_stt &&
                                  String(item.b_stt).includes('폐업'));
                              if (isClosed) {
                                setBizVerifyMsg(msg.bizNumClosed);
                                setIsBizVerified(false);
                                return;
                              }
                              setIsBizVerified(true);
                              setBizType(getBizTypeFromMiddleDigits(bizNum2));
                              setBizVerifyMsg(
                                msg.bizNumVerifySuccessFormat.replace(
                                  '{status}',
                                  item.b_stt || msg.bizNumStatusDefault
                                )
                              );
                            } catch (err) {
                              setBizVerifyMsg(msg.bizNumVerifyFail);
                              setIsBizVerified(false);
                            }
                          }}
                        >
                          {t.bizNumVerifyButton}
                        </button>
                      </div>
                      {bizNumHint && <p className="font_red">{bizNumHint}</p>}
                      {bizVerifyMsg && (
                        <p
                          style={{
                            color: isBizVerified ? '#2e7d32' : '#d32f2f',
                          }}
                        >
                          {bizVerifyMsg}
                        </p>
                      )}
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.bizType}</th>
                  <td>
                    <form>
                      <input
                        className="input_01"
                        type="text"
                        readOnly
                        disabled
                        value={
                          isBizVerified
                            ? bizType === 'BT003'
                              ? t.corporateBiz
                              : bizType === 'BT002'
                                ? t.individualBiz
                                : bizTypeOptions?.find(
                                    o => o.detailCode === bizType
                                  )?.detailCodeName || t.individualBiz
                            : t.bizTypeAutoSet
                        }
                        style={{
                          backgroundColor: '#f5f5f5',
                          cursor: 'not-allowed',
                        }}
                      />
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.storeName}</th>
                  <td>
                    <form>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <input
                          className="input_01"
                          type="text"
                          name=""
                          placeholder=""
                          maxLength={64}
                          style={{ flex: 1 }}
                          onChange={e => {
                            setStoreName(e.target.value);
                          }}
                          value={storeName}
                        />
                        <button
                          type="button"
                          className="button_05 button_gray"
                          onClick={openStoreSearchModal}
                        >
                          {t.storeSearch}
                        </button>
                      </div>
                      {selectedStoreNo && (
                        <p
                          className="font_gray"
                          style={{ marginTop: 4, fontSize: 12 }}
                        >
                          {t.storeSelectedFromCrawl} (No.{selectedStoreNo})
                        </p>
                      )}
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.representativeName}</th>
                  <td>
                    <form>
                      <input
                        className="input_01"
                        type="text"
                        name=""
                        placeholder={t.representativeNamePlaceholder}
                        maxLength={80}
                        onChange={e => {
                          setRepresentativeName(e.target.value);
                        }}
                        value={representativeName}
                      />
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.ageRestriction}</th>
                  <td>
                    <form>
                      <select
                        className="input_01"
                        value={ageRestriction}
                        onChange={e => {
                          setAgeRestriction(e.target.value);
                        }}
                      >
                        <option value={AgeRestriction.GENERAL}>
                          {t.ageRestrictionGeneral}
                        </option>
                        <option value={AgeRestriction.ADULT}>
                          {t.ageRestrictionAdult}
                        </option>
                      </select>
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.storeLogo}</th>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div>
                        <form>
                          <input
                            type="file"
                            name="fileInput"
                            onChange={changeFile}
                            accept=".jpg, .jpeg, .gif, .png"
                          />
                        </form>
                        <p className="font_gray">{t.fileDescription}</p>
                      </div>
                      <div style={{ width: '100px' }}></div>
                      <div>
                        {imageFile && (
                          <img
                            src={imageFile}
                            alt="Selected"
                            style={{ maxWidth: '100px', maxHeight: '100px' }}
                          />
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t.bizCertFile}</th>
                  <td>
                    <div>
                      <form>
                        <input
                          type="file"
                          name="bizCertFileInput"
                          onChange={changeBizCertFile}
                          accept=".pdf, .jpg, .jpeg, .png"
                        />
                      </form>
                      <p className="font_gray">{t.bizCertFileDescription}</p>
                      {bizCertFile && (
                        <p style={{ marginTop: 4, fontSize: 12 }}>
                          {bizCertFile.name}
                        </p>
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t.phoneNumber}</th>
                  <td>
                    <p className="font_gray" style={{ marginBottom: 8 }}>
                      {t.phoneNumberHint}
                    </p>
                    <form>
                      <input
                        className="input_02"
                        type="text"
                        name=""
                        maxLength={3}
                        placeholder="02/010/032"
                        value={sms1}
                        onChange={e => {
                          const raw = e.target.value || '';
                          const digits = raw.replace(/\D/g, '').slice(0, 3);
                          setPhoneHint(raw !== digits ? msg.digitsOnly : '');
                          setSms1(digits);
                        }}
                      />
                      -
                      <input
                        className="input_02"
                        type="text"
                        name=""
                        maxLength={4}
                        value={sms2}
                        onChange={e => {
                          const raw = e.target.value || '';
                          const digits = raw.replace(/\D/g, '').slice(0, 4);
                          setPhoneHint(raw !== digits ? msg.digitsOnly : '');
                          setSms2(digits);
                        }}
                      />
                      -
                      <input
                        className="input_02"
                        type="text"
                        name=""
                        maxLength={4}
                        value={sms3}
                        onChange={e => {
                          const raw = e.target.value || '';
                          const digits = raw.replace(/\D/g, '').slice(0, 4);
                          setPhoneHint(raw !== digits ? msg.digitsOnly : '');
                          setSms3(digits);
                        }}
                      />
                      {phoneHint && <p className="font_red">{phoneHint}</p>}
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.address}</th>
                  <td>
                    <div className="signup_04">
                      <form>
                        <input
                          className="input_01"
                          type="text"
                          id="postcode"
                          disabled
                          placeholder={t.postalCode}
                          value={zipCode}
                        />
                        <button
                          type="button"
                          className="button_05 button_gray"
                          onClick={openAddressSearch}
                        >
                          {t.searchAddress}
                        </button>
                        <br />
                        <input
                          className="input_06"
                          type="text"
                          id="roadAddress"
                          disabled
                          placeholder={t.roadAddress}
                          value={addr}
                        />
                        &ensp;
                        <input
                          className="input_06"
                          type="text"
                          id="jibunAddress"
                          disabled
                          placeholder={t.jibunAddress}
                          value={jibun}
                        />
                        <br />
                        <span
                          id="guide"
                          style={{ color: '#999', display: 'none' }}
                        ></span>
                        <input
                          className="input_06"
                          type="text"
                          id="detailAddress"
                          maxLength={64}
                          placeholder={t.detailAddress}
                          value={detailAddr}
                          onChange={e => {
                            setAddress(e);
                          }}
                        />
                      </form>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t.selectBank}</th>
                  <td>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <input
                        className="input_01"
                        type="text"
                        disabled
                        value={
                          bankCode
                            ? `${getBankNameByCode(bankCode)} (${bankCode})`
                            : t.accountPlaceholder
                        }
                        readOnly
                      />

                      <button
                        type="button"
                        className="button_05 button_blue"
                        onClick={() => {
                          handleResetValidationState();
                          handleOpenValidationModal();
                        }}
                      >
                        {t.accountValidation}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t.bankAccountNumber}</th>
                  <td>
                    <div>
                      <input
                        className="input_01"
                        type="text"
                        disabled
                        value={
                          accountNo ? String(accountNo) : t.accountPlaceholder
                        }
                        readOnly
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t.accountHolder}</th>
                  <td>
                    <div>
                      {validatedAccountBizType === 'BT003' ? (
                        <>
                          <input
                            className="input_01"
                            type="text"
                            maxLength={80}
                            placeholder={msg.corpHolderPlaceholder}
                            value={accountHolder}
                            onChange={e => setAccountHolder(e.target.value)}
                          />
                          <div
                            style={{
                              fontSize: 12,
                              color: '#d32f2f',
                              marginTop: 4,
                            }}
                          >
                            {msg.corpHolderHint}
                          </div>
                        </>
                      ) : (
                        <input
                          className="input_01"
                          type="text"
                          disabled
                          value={accountHolder || t.accountPlaceholder}
                          readOnly
                        />
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>{t.naverMapLink}</th>
                  <td>
                    <form>
                      <input
                        className="input_01"
                        type="text"
                        name=""
                        maxLength={255}
                        placeholder="https://"
                        value={naverUrl}
                        onChange={e => {
                          setNaverUrl(e.target.value);
                        }}
                      />
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.kakaoMapLink}</th>
                  <td>
                    <form>
                      <input
                        className="input_01"
                        type="text"
                        name=""
                        maxLength={255}
                        placeholder="https://"
                        value={kakaoUrl}
                        onChange={e => {
                          setKakaoUrl(e.target.value);
                        }}
                      />
                    </form>
                  </td>
                </tr>
                <tr>
                  <th>{t.instagramLink}</th>
                  <td>
                    <form>
                      <input
                        className="input_01"
                        type="text"
                        name=""
                        maxLength={255}
                        placeholder="https://"
                        value={instagramUrl}
                        onChange={e => {
                          setInstagramUrl(e.target.value);
                        }}
                      />
                    </form>
                  </td>
                </tr>
              </tbody>
            </table>
          </article>

          <article className="button_box_01">
            <button
              type="button"
              className="button_01 button_03 button_gray_line"
              onClick={() => navigate('/user-signup')}
            >
              {t.back}
            </button>
            <button
              type="button"
              className="button_01 button_03 button_gray_line"
              onClick={cancelUser}
            >
              {t.cancel}
            </button>
            <button
              type="button"
              className="button_01 button_03 button_red"
              onClick={goNextToUser}
            >
              {t.next}
            </button>
          </article>
        </section>
      </main>
    </>
  );
}
